import dynamic from 'next/dynamic';
import CircularProgress from '@mui/material/CircularProgress';
import type { File } from '../types';

const PDFViewerClient = dynamic(() => import('./PDFViewerClient'), {
  ssr: false,
  loading: () => <CircularProgress size={24} />,
});

const PDFViewer = ({ file }: { file: File }) => {
  return <PDFViewerClient file={file} />;
};
export default PDFViewer;
